const DEFAULT_MAX_LENGTH = 255;

export default function isName(
  name: string,
  options?: { allowNumbers?: boolean; maxLength?: number },
): boolean {
  const { allowNumbers = true, maxLength = DEFAULT_MAX_LENGTH } = options || {};
  if (name.length === 0 || name.length > maxLength) {
    return false;
  }
  const nameRegex = allowNumbers ? /^[a-z0-9 ,.'-]+$/i : /^[a-z ,.'-]+$/i;
  return nameRegex.test(name);
}
